/* import __COLOCATED_TEMPLATE__ from './selection-grid.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import { copy as EmberCopy } from 'ember-copy';
import utilities from '../utils/utilities';

var constructData = function (parts, recommendedParts, id) {
  if (recommendedParts.length <= 0) {
    for (var l = 0; l < parts.length; l++) {
      parts[l].recommended = false;
    }
  } else {
    for (var i = 0; i < parts.length; i++) {
      for (var s = 0; s < recommendedParts.length; s++) {
        if (parts[i].id == recommendedParts[s].id) {
          parts[i].recommended = true;
          break;
        } else {
          parts[i].recommended = false;
        }
      }
    }
  }

  for (var y = 0; y < parts.length; y++) {
    parts[y].isSelected = parts[y].id == id ? true : false;
  }

  return parts.sort(function (a, b) {
    var xR = a.recommended,
      yR = b.recommended,
      xO = a.order,
      yO = b.order;
    return xR !== yR ? compare(yR, xR) : compare(xO, yO);
  });
};

var compare = function (a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};

////////////////////////////////////////////////////////////////////////////////////
// selection-grid - Component that displays list of parts and recommendation      //
////////////////////////////////////////////////////////////////////////////////////

export default class SelectionGrid extends Component {
  tagName = '';
  partsListElement = null;
  @service('aditools-analytics') analytics;

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('parts', 'recommendedParts', 'selectedPart.id') get partsList() {
    return constructData(this.parts, this.recommendedParts, this.selectedPart.id);
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  // Resize function for grid
  resizeGrid() {
    let selectionGrid = document.querySelector('#selectionGrid');
    let selectorDropdown = document.querySelector('#selectorDropdown');
    if (utilities.findBootstrapEnvironment() == 'xl' || utilities.findBootstrapEnvironment() == 'lg') {
      selectionGrid.style.width = '1000px';
      selectorDropdown.style.width = '1000px';
    } else {
      let partSelector = document.querySelector('#partSelector');
      selectionGrid.style.width = `${partSelector.offsetWidth.toString()}px`;
      selectorDropdown.style.width = `${partSelector.offsetWidth.toString()}px`;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertingGrid(elem) {
    this.partsListElement = elem;
    this.resizeGrid();
    window.addEventListener('resize', this.resizeGrid);
  }

  @action destroyingGrid() {
    window.removeEventListener('resize', this.resizeGrid);
    this.partsListElement = null;
  }

  @action selectPart(itemId) {
    if (itemId !== this.selectPart.id) {
      let newSelectedItem = this.partsList.find((part) => part.id === itemId);
      let partToSelect = EmberCopy(newSelectedItem, true);
      if (partToSelect.gainType == 'range') {
        partToSelect.selectedGainInput = EmberCopy(
          {
            description: this.selectedPart.selectedGainInput.description,
            id: this.selectedPart.selectedGainInput.id,
          },
          true,
        );
      } else if (partToSelect.gainType == 'discrete') {
        for (var i = 0; i < partToSelect.gainInputs.length; i++) {
          if (partToSelect.gainInputs[i].id == this.selectedPart.selectedGainInput.id) {
            partToSelect.selectedGainInput = EmberCopy(partToSelect.gainInputs[i], true);
            break;
          }
        }
      }
      this.updateField('selectedPart', partToSelect);
      this.analytics.setWebEvent(this.toolName, 'productSelected', partToSelect.id);
    }
    this.toggleDropdown();
  }

  @action oddEvenCss(index) {
    return index % 2 === 0 ? ' even' : ' odd';
  }
}
